import React, { useState, useEffect, createContext, useContext, useCallback } from 'react';
import axios from 'axios';

// import settings from '../settings';


const ConfigContext = createContext({});


const xconfig = window.xconfig || {
    axios: {
        baseURL:'',
        backend:'',
        beta:false,
    },
    router:{
        routesBaseName: '/'
    },
    runtime:{
        showVPNameOnPlan:false,
    }
};


const defaultConfig = {
    axios: {
        baseURL:xconfig.axios.baseURL,
        backend:xconfig.axios.backend,
        beta:xconfig.axios.beta,
    },
    router:{
        routesBaseName: xconfig.router.routesBaseName
    },
    runtime:{
        showVPNameOnPlan: xconfig?.runtime?.showVPNameOnPlan ?? false,
    },
    cookieconsent:"PanoViewer.CookiesAllowed",
    debugAxios:true,
    debugPing:false,
    development:true,
};


function ConfigProvider(props) {

    const [ config, setConfig ] = useState(defaultConfig);

    const apiCallUrl = useCallback((apiCall) => {
        if (typeof apiCall !== 'string')
            throw '';
        if ((apiCall = apiCall.trim()).length === 0)
            throw '';

        const protocol = window.location.protocol.toUpperCase();
        if (protocol !== "HTTP:" && protocol !== "HTTPS:")
            throw new Error("err");

        if (apiCall[0] !== '/')
            apiCall = '/' + apiCall;
        return `${config.axios.backend}${apiCall}`;
    }, [config]);


    const apiCallUrlFull = useCallback((apiCall) => {
        return `${axios.defaults.baseURL}${apiCallUrl(apiCall)}`;
    }, [apiCallUrl]);


    axios.defaults.baseURL = config.axios.baseURL;
    if (config.axios.beta) {
        // axios.defaults.params = {
        //     beta:true
        // }
    }

    axios.defaults.xdebug = config.debugAxios;
    axios.defaults.xdebugping = config.debugPing;

    return (
        <ConfigContext.Provider value={{
            apiCallUrl,
            apiCallUrlFull,
            routesBaseName:config.router.routesBaseName,
            cookieconsent:config.cookieconsent,
            debugAxios:config.debugAxios,
            debugPing:config.debugPing,
            development:config.development,
            config
        }} {...props} />
    );
}


const useConfig = () => useContext(ConfigContext);


export { ConfigProvider, useConfig }


//return `${window.location.origin}/visuelse-server${apiCall}`;
//return `https://192.168.1.142/visuelse-server${apiCall}`;